import {defineStore} from "pinia";
import PermissionsRepository from "@/Repositories/PermissionsRepository";

export const PermissionsStore = defineStore('PermissionsStore', {
    state: () => ({
        permissions: [],
    }),

    actions: {
        async setPermissions() {
            let response = await PermissionsRepository.getPermissions()
                .then((response) => response.data)
                .catch(() => []);
            this.permissions = this.getPermissionsNames(response);
        },

        getPermissionsNames(permissions) {
            return permissions.map((permission) => permission.name);
        },

        checkPermission(permissionName) {
            return this.permissions.some(permission => permission === permissionName);
        }
    }
});
